import APIBase from './base'

export default class APIRemote extends APIBase {
  constructor(config) {
    super(config)

    // chunk preprocessor
    this.preprocessor = function(data) {
      delete data.id
      return data
    }
  }
}
